import { render, staticRenderFns } from "./other-customer-question-item.vue?vue&type=template&id=4d11db8e&scoped=true&"
import script from "./other-customer-question-item.vue?vue&type=script&lang=js&"
export * from "./other-customer-question-item.vue?vue&type=script&lang=js&"
import style0 from "./other-customer-question-item.vue?vue&type=style&index=0&id=4d11db8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d11db8e",
  null
  
)

export default component.exports